import { Pipe, PipeTransform } from "@angular/core";
import { CustomerTaxCategory, DealType, NotificationType, OverdueCategory, PaymentMethod } from "../model";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    standalone: true,
    name: 'notificationType',
    pure: true
})
export class NotificationTypePipe implements PipeTransform {

    constructor() {

    }

    transform(value: NotificationType): string {
        if (value === NotificationType.RenewalOffer) {
            return 'Renewal Offer';
        } else if (value === NotificationType.UpcomingRenewalNotification) {
            return 'Auto Renewal';
        } else {
            return '-';
        }
    }

}
